export const LateFeeConfigurationFragment = gql`
  fragment LateFeeConfigurationFragment on LateFeeConfiguration {
    id
    accrualLimitDateTemplate {
      ...DateTemplateFragment
    }
    feeTemplate {
      ...LateFeeFragment
    }
  }
  fragment LateFeeFragment on Fee {
    id
    latestVersion {
      id
      lateFeeAccrualPercent
      lateFeeAccrualPeriod
      lateFeeBasePercent
    }
  }
`
